var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadphone = function SvgHeadphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23 17.5h3V15c0-7.964-4.224-13-12-13S2 7.036 2 15v2.426l-1.071.077A1 1 0 0 0 0 18.49V15C0 6.001 5.034 0 14 0s14 6.001 14 15v9a4 4 0 0 1-4 4h-1a4 4 0 0 1-4-4v-2.5a4 4 0 0 1 4-4M2 19.431l-.929.066a1 1 0 0 1-1.068-.926L0 18.508V24a4 4 0 0 0 4 4h1a4 4 0 0 0 4-4v-2.778a4 4 0 0 0-4.285-3.99L2 17.426zm0 0 2.858-.204A2 2 0 0 1 7 21.222V24a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zM26 24v-4.5h-3a2 2 0 0 0-2 2V24a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2",
    clipRule: "evenodd"
  })));
};
export default SvgHeadphone;